import { useEffect } from '@wordpress/element'

export const SameDay = (props) => {
    if (window.dhlpwc_block_data.sdd_as_time_window) {
        const sameDayElement = document.getElementById('radio-control-0-dhlpwc-home-same-day');
        if (sameDayElement) {
            sameDayElement.parentElement.style.display = "none";
        }

        const sameDayNoNeighborElement = document.getElementById('radio-control-0-dhlpwc-home-no-neighbour-same-day');
        if (sameDayNoNeighborElement) {
            sameDayNoNeighborElement.parentElement.style.display = "none";
        }
    }

    const sameDayDeliveryMethods = [
        'dhlpwc-home-same-day',
        'dhlpwc-home-no-neighbour-same-day'
    ]

    useEffect(() => {
        if (sameDayDeliveryMethods.indexOf(props.selectedShippingMethod) !== -1) {
            // Wordpress doesn't like it when we post raw data, so we post it as a form instead
            const formData = new FormData();
            formData.append('action', 'dhlpwc_get_delivery_times')
            formData.append('shipping_method', props.selectedShippingMethod)
            formData.append('postal_code', props.postalCode)
            formData.append('country_code', props.countryCode)
            fetch(
                window.dhlpwc_block_data['ajax_url'],
                {
                    method: 'POST',
                    body: formData
                }
            ).then(async response => {
                response = await response.json()
                const sameDayDeliveryTime = response.data[0]['identifier'].split('___')
                const formData = new FormData();
                formData.append('action', 'dhlpwc_delivery_time_selection_sync')

                formData.append('selected', true)
                formData.append('date', sameDayDeliveryTime[0] ?? '')
                formData.append('start_time', sameDayDeliveryTime[1] ?? '')
                formData.append('end_time', sameDayDeliveryTime[2] ?? '')

                fetch(
                    window.dhlpwc_block_data['ajax_url'],
                    {
                        method: 'POST',
                        body: formData
                    }
                )
            })
        }
    }, [props.postalCode, props.countryCode, props.selectedShippingMethod]);
};
